<template>
  <v-card class="px-8 py-5">
    <v-toolbar flat>
      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
    </v-toolbar>
    <formWrapper :validator="$v.form">
      <v-form @submit.prevent="handleSubmit">
        <v-row>
          <v-col
            v-if="$route.name === 'edit_program'"
            cols="12"
            md="6"
            class="mx-auto"
          >
            <locale-select v-model="locale" @change="changeLocale" />
          </v-col>
          <v-col cols="12">
            <span class="headings gray--text">{{
              $t("labels.required_image")
            }}</span>
            <new-image-upload
              class="file-upload__image"
              :imgUrl="form.main_image ? form.main_image.path : ''"
              :imgId="form.main_image ? form.main_image.id : ''"
              @fileSelected="handleMainImage"
              :maxSize="main_image_Size"
            />
          </v-col>
          <v-col cols="12" md="6">
            <form-group name="name" attribute="fields.name">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.name"
                  outlined
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12" md="6">
            <form-group name="label_id" attribute="fields.label_id">
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  outlined
                  v-bind="attrs"
                  v-on="listeners"
                  :items="labels"
                  item-text="name"
                  item-value="id"
                  :loading="labelLoading"
                  v-model.number="form.label_id"
                ></v-select>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12" md="6">
            <form-group name="price" attribute="fields.price">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  type="number"
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.price"
                  outlined
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12" md="6">
            <v-switch v-model="form.per_month" :label="$t('labels.per_month')">
            </v-switch>
          </v-col>
          <v-col cols="12">
            <form-group name="description" attribute="fields.description">
              <template slot-scope="{ attrs, listeners }">
                <v-textarea
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.description"
                  outlined
                  no-resize
                  rows="8"
                >
                </v-textarea>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12">
            <section class="file-upload__gallery mt-2">
              <multi-image-upload
                class="file-upload__gallery--upload"
                :maxSize="photo_size"
                @fileSelected="handleMultiPhotos"
                @handle_delete_image="handleDelteImag"
                :imgsUrl="form.media"
              />
            </section>
          </v-col>
        </v-row>
        <v-btn
          type="submit"
          :loading="loading"
          :disabled="$v.form.$invalid"
          class="primary"
        >
          <span>{{ $t("button.save") }}</span>
          <v-icon small right>mdi-send</v-icon>
        </v-btn>
      </v-form>
    </formWrapper>
  </v-card>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import { maxWords } from "@/utils/validate";
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData,
} from "@/helpers/apiMethods";
export default {
  name: "FormActionProgram",
  data() {
    return {
      form: {
        name: "",
        label_id: "",
        price: "",
        main_image: "",
        description: "",
        per_month: false,
        photos: [],
      },

      labels: [],
      main_image_Size: 2.48,
      photo_size: 1.24,
      locale: this.locale || "en",
      loading: false,
      labelLoading: true,
    };
  },
  computed: {
    formTitle() {
      if (this.$route.params.slug) {
        return this.$t("headings.edit_program");
      } else {
        return this.$t("headings.create_program");
      }
    },
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      label_id: {
        required,
      },
      description: {
        required,
        minLength: minLength(3),
        maxWords: maxWords(100),
      },
      price: {
        required,
        numeric,
      },
      per_month: {
        required,
      },
      main_image: {
        required,
      },
    },
  },
  methods: {
    handleGetLables() {
      IndexData({ reqName: "labels" }).then((res) => {
        const { data } = res.data;
        this.labels = data;
        this.labelLoading = false;
      });
    },
    handleMainImage(img) {
      this.form.main_image = img.file;
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },
    handleMultiPhotos(photos) {
      this.form.photos = photos;
    },
    handleDelteImag(index) {
      this.form.media.splice(index, 1);
    },
    handleSubmit() {
      this.loading = true;
      const formData = new FormData();
      if (this.$route.name === "edit_program") {
        delete this.form.main_image;
      }
      Object.keys(this.form).forEach((key) => {
        if (
          key !== "photos" &&
          key !== "media" &&
          key !== "label" &&
          key !== "date"
        ) {
          formData.append(key, this.form[key]);
        }
      });
      this.form["photos"].forEach((photo) =>
        formData.append("photos[]", photo)
      );
      formData.append("locale", this.locale);

      if (this.$route.name === "create_program") {
        // in case create
        this.createProgram(formData);
      } else {
        // in case edit
        formData.append("_method", "put");
        this.editProgram(formData);
      }
    },
    editProgram(data) {
      const { slug } = this.$route.params;
      UpdateData({ reqName: "programs", data, param: slug })
        .then(() => this.$router.push({ name: "programs" }))
        .finally(() => (this.loading = false));
    },
    async createProgram(data) {
      try {
        await StoreData({ reqName: "programs", data });
        this.$router.push({ name: "programs" });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    handleShowData(locale) {
      const { slug } = this.$route.params;

      if (slug) {
        ShowData({ reqName: "programs", param: slug, locale }).then((res) => {
          const { program } = res.data;

          this.form = {
            ...this.form,
            label_id: program.label.id,
            ...program,
          };
        });
      }
    },
  },
  watch: {
    $route: {
      handler() {
        this.handleGetLables();
        this.handleShowData();
      },
      immediate: true,
    },
  },
};
</script>
